import { AppThunkAction } from '../reducers';

// Actions
import * as Actions from '../actions';

// Services
import * as service from '../../services/PractitionerConsumptions.Services';

// Models
import { PractitionerConsumption } from '../../models/Entities/Practitioners/PractitionerConsumption';
import { ErrorType } from '../../models/HttpError';
import { PractitionerConsumptionTotal } from '../../models/Entities/Practitioners/PractitionerConsumptionTotal';
import { NewPractitionerConsumption } from '../../models/Entities/Practitioners/NewPractitionerConsumption';
import { IPagedResult } from '../../models/HttpPagedResult';
import { IConsumptionsFilters } from '../../models/Filters/ConsumptionsFilters';

// Interface for practitioner consumption filters
interface PractitionerConsumptionFilters {
    searchText?: string;
    concepts?: number[];
    currencies?: string[];
    patients?: string[];
    practitioners?: string[];
    protocols?: number[];
    stagesName?: string[];
    statuses?: number[];
}

type KnownAction =
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetAllByPractitionerRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetAllByPractitionerSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetAllByPractitionerFailureAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetByIdRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetByIdSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetByIdFailureAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionCreateRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionCreateSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionCreateFailureAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionUpdateRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionUpdateSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionUpdateFailureAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionDeleteRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionDeleteSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionDeleteFailureAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetTotalByStatusRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetTotalByStatusSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionGetTotalByStatusFailureAction
    
    // Change status
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeStatusRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeStatusSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeStatusFailureAction
    
    // change consumption contract concept association
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeContractConceptRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeContractConceptSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeContractConceptFailureAction
    
    // change producer
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeProducerRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeProducerSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeProducerFailureAction
    
    // change amount 
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeAmountRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeAmountSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeAmountFailureAction
    
    // change medical service
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeMedicalServiceRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeMedicalServiceSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionChangeMedicalServiceFailureAction
    
    // Consumption to Settle actions
    | Actions.PractitionerConsumptions.PractitionerConsumptionToSettleGetAllRequestAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionToSettleGetAllSuccessAction
    | Actions.PractitionerConsumptions.PractitionerConsumptionToSettleGetAllFailureAction
    ;

export const ActionCreators = {    GetAllPractitionerConsumptionsByPractitioner:
        (
            practitionerId: string, 
            pageNumber: number,
            pageSize: number,
            filters?: IConsumptionsFilters
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_FAILURE',
                        practitionerId: practitionerId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_REQUEST',
                        practitionerId: practitionerId
                    });                    
                    
                    service.GetAllConsumptionByPractitionerId(
                        token,
                        practitionerId,
                        pageNumber,
                        pageSize,
                        filters
                    )
                        .then((list: IPagedResult<PractitionerConsumption[]>) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_SUCCESS',
                                practitionerId: practitionerId,
                                consumptions: list.data,
                                paginationState: {
                                    pageNumber: list.pageNumber,
                                    pageSize: list.pageSize,
                                    firstPage: list.firstPage,
                                    lastPage: list.lastPage,
                                    totalPages: list.totalPages,
                                    totalRecords: list.totalRecords,
                                    nextPage: list.nextPage,
                                    previousPage: list.previousPage
                                }
                                
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_FAILURE',
                                practitionerId: practitionerId,
                                error: error
                            });
                        });
                }
            },
    GetPractitionerConsumptionById:
        (
            practitionerId: string, 
            consumptionId: string
        ): AppThunkAction<KnownAction> =>        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_GET_BYID_FAILURE',
                    consumptionId: consumptionId,
                    practitionerId: practitionerId,

                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_GET_BYID_REQUEST',
                    practitionerId: practitionerId,	
                    consumptionId: consumptionId
                });

                service.GetPractitionerConsumptionById(consumptionId, token)
                .then((consumption: PractitionerConsumption) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_GET_BYID_SUCCESS',
                        consumption: consumption
                    });
                })
                .catch((error: ErrorType) => {
                        dispatch({
                            type: 'PRACTITIONERCONSUMPTION_GET_BYID_FAILURE',
                            practitionerId: practitionerId,
                            consumptionId: consumptionId,
                            error: error
                        });
                    }
                );
            }
        },
    CreatePractitionerConsumption:
        (
            consumption: NewPractitionerConsumption
        ): AppThunkAction<KnownAction> =>        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CREATE_FAILURE',
                    practitionerId: consumption.practitionerId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CREATE_REQUEST',
                    consumption: consumption
                });

                service.CreatePractitionerConsumption(token, consumption)
                .then((consumption: PractitionerConsumption) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_CREATE_SUCCESS',
                        consumption: consumption
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_CREATE_FAILURE',
                        practitionerId: consumption.practitionerId,
                        error: error
                    });
                });
            }
        },
    UpdatePractitionerConsumption:
        (
            consumption: PractitionerConsumption
        ): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_UPDATE_FAILURE',
                    practitionerId: consumption.practitionerId,
                    consumptionId: consumption.id,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_UPDATE_REQUEST',
                    consumption: consumption
                });

                service.UpdatePractitionerConsumption(token, consumption)
                .then((consumption: PractitionerConsumption) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_UPDATE_SUCCESS',
                        consumption: consumption
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_UPDATE_FAILURE',
                        practitionerId: consumption.practitionerId,
                        consumptionId: consumption.id,
                        error: error
                    });
                });
            }
        },
    DeletePractitionerConsumption:
        (
            practitionerId: string,
            consumptionId: string
        ): AppThunkAction<KnownAction> =>        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_DELETE_FAILURE',
                    practitionerId: practitionerId,
                    consumptionId: consumptionId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_DELETE_REQUEST',
                    practitionerId: practitionerId,
                    consumptionId: consumptionId
                });

                service.DeletePractitionerConsumption(token, consumptionId)
                .then(() => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_DELETE_SUCCESS',
                        practitionerId: practitionerId,
                        consumptionId: consumptionId
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_DELETE_FAILURE',
                        practitionerId: practitionerId,
                        consumptionId: consumptionId,
                        error: error
                    });
                });
            }
    },
    GetTotalsByStatus:
        (
            practitionerId: string,
            status: number
        ): AppThunkAction<KnownAction> =>        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE',
                    practitionerId: practitionerId,
                    status: status,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST',
                    status: status,
                    practitionerId: practitionerId
                });                service.GetPractitionerConsumptionTotals(practitionerId, status, token)
                .then((totals: PractitionerConsumptionTotal[]) => {
                    const auxTotals = totals?.map((total: PractitionerConsumptionTotal) => {
                        return {
                            status: status,
                            currencyCode: total.currencyCode,
                            totalAmount: total.totalAmount
                        };
                    });

                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS',
                        practitionerId: practitionerId,
                        status: status,
                        total: auxTotals
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE',
                        practitionerId: practitionerId,
                        status: status,
                        error: error
                    });
                });
            }
        },
    // Change status
    ChangeStatus:
        (
            practitionerId: string,
            consumptionId: string,
            status: number,
            isForAll: boolean
        ): AppThunkAction<KnownAction> =>        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_FAILURE',
                    practitionerId: practitionerId,
                    status: status,
                    consumptionId: consumptionId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_REQUEST',
                    practitionerId: practitionerId,
                    consumptionId: consumptionId,
                    status: status,
                    isForAll: isForAll
                });

                service.ChangePractitionerConsumptionStatus(token, practitionerId, consumptionId, status, isForAll)
                .then(() => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_SUCCESS',
                        practitionerId: practitionerId,
                        consumptionId: consumptionId,
                        status: status,
                        isForAll: isForAll
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_FAILURE',
                        practitionerId: practitionerId,
                        status: status,
                        consumptionId: consumptionId,
                        error: error
                    });
                });
            }
        },
    // change producer
    ChangeProducer: 
        (
            practitionerId: string,
            consumptionId: string,
            producerId: string
        ): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_FAILURE',
                    practitionerId: practitionerId,
                    consumptionId: consumptionId,
                    producerId: producerId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_REQUEST',
                    practitionerId: practitionerId,
                    consumptionId: consumptionId,
                    producerId: producerId
                });

                service.SetConsumptionProducer(token, consumptionId, producerId)
                .then(() => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_SUCCESS',
                        practitionerId: practitionerId,
                        consumptionId: consumptionId,
                        producerId: producerId,
                        
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTION_CHANGE_PRODUCER_FAILURE',
                        practitionerId: practitionerId,
                        consumptionId: consumptionId,
                        producerId: producerId,
                        error: error
                    });
                });
            }
        },
    // change amount
    ChangeAmount: 
    (
        practitionerId: string,
        consumptionId: string,
        amount: number,
        currencyCode: string
    ): AppThunkAction<KnownAction> =>
    (dispatch, getState) => {
        const appState = getState();
        let token: string = '';

        if (appState.oidc?.user?.access_token === undefined) {
            dispatch({
                type: 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_FAILURE',
                practitionerId: practitionerId,
                consumptionId: consumptionId,
                amount: amount,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        } else {
            token = appState.oidc.user.access_token;
        };

        if (appState) {
            dispatch({
                type: 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_REQUEST',
                practitionerId: practitionerId,
                consumptionId: consumptionId,
                amount: amount
            });

            service.SetConsumptionAmount(token, consumptionId, amount, currencyCode)
            .then((consumption: PractitionerConsumption) => {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_SUCCESS',
                    practitionerId: practitionerId,
                    consumption: consumption,
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_FAILURE',
                    practitionerId: practitionerId,
                    consumptionId: consumptionId,
                    amount: amount,
                    error: error
                });
            });
        }
    }
    // get consumptions to settle
    , GetPractitionerConsumptionsToSettle:
        (
            practitionerId: string
        ): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_FAILURE',
                    practitionerId: practitionerId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            if (appState) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_REQUEST',
                    practitionerId: practitionerId
                });
                service.GetPractitionerConsumptionByStatus(practitionerId, 6, token)
                .then((consumptionsToSettle: PractitionerConsumption[]) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_SUCCESS',
                        practitionerId: practitionerId,
                        consumptions: consumptionsToSettle,
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONTOSETTLE_GETALL_FAILURE',
                        practitionerId: practitionerId,
                        error: error
                    });
                });
            }
        }
};
